var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconsProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 10.5,
    viewBox: "0 0 17.5 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375-6.125v1.75h8.75v-1.75a1.752,1.752,0,0,1,1.75-1.75h.875A2.626,2.626,0,0,0,13.125-10.5H4.375A2.626,2.626,0,0,0,1.75-7.875h.875A1.752,1.752,0,0,1,4.375-6.125ZM15.75-7h-.875A.874.874,0,0,0,14-6.125V-3.5H3.5V-6.125A.874.874,0,0,0,2.625-7H1.75A1.752,1.752,0,0,0,0-5.25,1.746,1.746,0,0,0,.875-3.743V-.437A.439.439,0,0,0,1.313,0h1.75A.439.439,0,0,0,3.5-.437V-.875H14v.438A.439.439,0,0,0,14.438,0h1.75a.439.439,0,0,0,.438-.437V-3.743A1.746,1.746,0,0,0,17.5-5.25,1.752,1.752,0,0,0,15.75-7Z",
    transform: "translate(0 10.5)",
    fill: "#888075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconsProducts);
export default __webpack_public_path__ + "static/media/navIcons_Products.73bc01bb4e9d5793fd4cb79c71b1c498.svg";
export { ForwardRef as ReactComponent };